import { type VideoCodec, videoCodecs } from 'livekit-client';

export function isVideoCodec(codec: string): codec is VideoCodec {
    return videoCodecs.includes(codec as VideoCodec);
}

export type ConnectionDetails = {
    serverUrl: string;
    roomName: string;
    participantName: string;
    participantToken: string;
};
